import { nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppFileHref - ONE COPY of the page-href file arithmetic (fix campaign 2026-10-15): `People/Tomo/<Name>`
// from a page href `People/Tomo/Tomo.html`, or "" when the href holds no folder. Pure, cannot throw; the
// guarded caller (`AppTranslate.FileOf`) keeps its own error gate and fault boundary. The three copies this
// replaces: `AppAiChat.FileOf`, `AppPins.FileOf`, `AppTranslate.FileOf`.

export class AppFileHref {
    /** `People/Tomo/<Name>` from a page href, "" when there is no folder in it (kept as given, URI-encoding and all). */
    public static FileOf = (Href: string, Name: string): string => {
        const Clean: string = nz(Href).replace(/\\/g, "/").trim();
        const Cut: number = Clean.lastIndexOf("/");
        if (Cut <= 0) { return ""; }
        return Clean.substring(0, Cut) + "/" + nz(Name);
    };
}
